/**
 * Where one message file's bytes live (#1069 Story 4.2, AC 1, AC 12).
 *
 * ⚠️ THE CLIENT BUILDS THIS, THE SERVER DOES NOT SEND IT. `MessageFile` carries
 * ids and metadata and no URL, deliberately: a URL in the payload would put the
 * API's own shape into the wire contract, and would give Story 4.3 — whose job
 * is proving these files are reachable no other way — a second place to have to
 * prove it about.
 *
 * ⚠️ THE THREAD IS IN THE PATH, AND THAT IS AN ACCEPTANCE CRITERION (AC 1).
 * The URL cannot be constructed without already knowing which conversation the
 * file belongs to, and the server authorises against that thread before it
 * reads a byte. Do not add a shorter `/files/:id` spelling "for convenience":
 * it is the shape itself that carries the guarantee.
 *
 * ⚠️ ABSOLUTE, because `fetchMessageFile` calls `fetch` directly rather than
 * going through the API provider, so a path relative to the API root would
 * resolve against the web app's origin on web and against nothing at all on
 * native.
 */
import { getResolvedApiBaseUrl } from '../api';

/** Mirrors `apiProvider`'s `ROOT`: every correspondence route is versioned. */
const ROOT = '/v1';

const encode = (value: string): string => encodeURIComponent(value);

export const messageFileUrl = (args: {
  threadId: string;
  messageId: string;
  fileId: string;
}): string =>
  `${getResolvedApiBaseUrl()}${ROOT}/correspondence/threads/${encode(
    args.threadId,
  )}/messages/${encode(args.messageId)}/files/${encode(args.fileId)}`;
